<template>
    <div id="optimized-canvas-lists-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/menu')"
                icon="arrow-left"
                :label="trans('pages.optimized_canvas_lists.back')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/canvasworkoverview')"
                icon="cogs"
                :label="
                    trans('pages.optimized_canvas_lists.to_canvas_overview')
                "
            />
        </actions-menu>

        <ui5-list
            id="pleatinglistoverview-list"
            growing="Button"
            :more-text="
                loading ? '' : trans('pages.optimized_canvas_lists.load_more')
            "
            @load-more="load"
        >
            <ui5-li
                v-for="list in lists"
                :key="list.id"
                @click="goToOptimizedCanvasDetails(list.optimizedProductlistId)"
            >
                <span
                    class="urgent"
                    v-if="list.urgent"
                >
                    !
                </span>
                {{ list.optimizedProductlistId }} - {{ list.deadline }} -
                {{ list.optimizedProductlistCreatedAt }} -
                {{ list.canvasType }} {{ list.canvasColor }} -
                {{
                    list.status ||
                    trans('pages.optimized_canvas_lists.status_unknown')
                }}
            </ui5-li>
        </ui5-list>

        <spinner-text
            v-if="loading"
            class="spinner-container"
        >
            {{ trans('pages.optimized_canvas_lists.fetching_canvas_orders') }}
        </spinner-text>

        <div v-if="finished">
            {{ trans('pages.optimized_canvas_lists.no_more_canvas_orders') }}
        </div>
    </div>
</template>
<script>
import optimizedProductListApi from '../api/optimizedProductList';
import SpinnerText from '../components/loader/SpinnerText';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: {
        SpinnerText,
        ActionsMenu,
        ActionsMenuItem,
    },
    mixins: [localization],
    data() {
        return {
            finished: false,
            loading: false,
            lists: null,
        };
    },
    methods: {
        goToOptimizedCanvasDetails(optimizedProductlistId) {
            this.$router.push(
                '/optimizedproductlistdetails/' + optimizedProductlistId
            );
        },
        load() {
            this.finished = false;
            this.loading = true;

            optimizedProductListApi
                .list('DOEKBON', this.lists ? this.lists.length : 0, 50)
                .then((response) => {
                    if (!this.lists) {
                        this.lists = response.data.data;
                    } else {
                        this.lists.push(...response.data.data);
                    }
                    if (response.data.data.length == 0) {
                        this.finished = true;
                    }
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.optimized_canvas_lists.error_fetching_canvas_orders'
                        )
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.load();
    },
};
</script>
